// eslint-disable-next-line import/prefer-default-export
export const CORPORATE_ATTRIBUTES_ID = {
  STARTUP: 1,
  ENTERPRISE: 2,
  INVESTOR: 3,
  PUBLIC: 5,
  RESEARCH: 6,
  OTHERS: 7,
} as const;
